import { useState } from 'react';
import Tabs from '@cloudscape-design/components/tabs';
import { UrlSafetyTab, AboutUrlSafetyTab } from '@components/index';

const UrlSafetyTool = () => {
  const [activeTabId, setActiveTabId] = useState('analyzer');

  return (
    <Tabs
      activeTabId={activeTabId}
      onChange={({ detail }) => setActiveTabId(detail.activeTabId)}
      tabs={[
        {
          id: 'analyzer',
          label: 'URL Analyzer',
          content: <UrlSafetyTab />,
        },
        {
          id: 'about',
          label: 'About URL Analyzer',
          content: <AboutUrlSafetyTab />,
        },
      ]}
    />
  );
};

export default UrlSafetyTool;

